'use client';

import { cn } from '@core/utils';

import { AdBadge } from '@/app/_components/ads';
import { AD_UNIT_IDS, BREAKPOINTS } from '@/constants';
import { isBannerAdHidden, useAd } from '@/hooks/useAd';
import { useMediaQuery } from '@/hooks/useMediaQuery';

export const HomeFeedListAdBanner = () => {
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  const width = isDesktop ? 600 : 320;
  const height = isDesktop ? 314 : 50;
  const unitId = isDesktop
    ? AD_UNIT_IDS.HOME_FEED_LIST_BANNER_P
    : AD_UNIT_IDS.HOME_FEED_LIST_BANNER_M;

  return (
    <HomeFeedListAdBannerSlot
      key={unitId}
      unitId={unitId}
      width={width}
      height={height}
    />
  );
};

interface HomeFeedListAdBannerSlotProps {
  unitId: string;
  width: number;
  height: number;
}

const HomeFeedListAdBannerSlot = ({
  unitId,
  width,
  height,
}: HomeFeedListAdBannerSlotProps) => {
  const { containerRef, adState } = useAd(unitId, {
    type: 'banner',
  });

  if (isBannerAdHidden(adState)) return null;

  return (
    <div className="bg-Gray-white py-20">
      <div className="relative mx-auto w-fit">
        <AdBadge className="right-12 top-12" />
        <div
          ref={containerRef}
          className={cn(
            'overflow-hidden bg-Gray-100',
            adState === 'idle' && 'hidden',
            adState === 'loading' && 'animate-pulse',
          )}
          style={{
            width,
            height,
          }}
        />
      </div>
    </div>
  );
};
